import * as React from "react"
const UploadIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width={12} height={12}>
    <title>{"UI-Style-Guidelines (1)"}</title>
    <g fill="#2F2F30" fillRule="evenodd" stroke="#2F2F30" strokeWidth={0.3}>
      <path d="M10.809 4H8.495a.186.186 0 0 0-.192.182c.005.104.09.185.192.181h2.123v6.273H1.383V4.363h2.122c.1.002.184-.079.188-.181A.186.186 0 0 0 3.505 4H1.191A.186.186 0 0 0 1 4.182v6.636c.004.105.09.186.191.182h9.618a.186.186 0 0 0 .191-.182V4.182A.186.186 0 0 0 10.809 4" />
      <path d="m4.37 2.78 1.414-1.168v5.207C5.79 6.92 5.886 7 6 7s.209-.08.216-.181V1.612L7.63 2.78c.087.07.22.07.307 0A.163.163 0 0 0 8 2.653a.163.163 0 0 0-.064-.128L6.153 1.053l-.016-.012H6.13l-.01-.011-.01-.004-.009-.005-.007-.004h-.04L6.042 1H5.916l-.013.017h-.01l-.005.009-.008.004-.012.007h-.005l-.017.016-1.782 1.475A.163.163 0 0 0 4 2.656c0 .049.023.095.064.127.088.07.22.07.307 0" />
    </g>
  </svg>
)
export default UploadIcon
